import angular from 'angular'
import details from './details'
import stocks from './stocks'
import receiveBranchInvoice from './receiveBranchInvoice'
import distribution from './distribution'
import retrieve from './retrieve'
import application from './application'
import InventoryQuery from './InventoryQuery'

export default angular.module('outputManage.stock', [details, stocks, distribution, retrieve, receiveBranchInvoice, application, InventoryQuery]).config([
    '$stateProvider',
    ($stateProvider) => {
        $stateProvider.state('outputManage.stock', {
            url: '/stock',
            template: '<div ui-view></div>',
            abstract: true,
            title: '库存管理',
        })
    },
]).name



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/index.js